import backgroundImage from '../assets/images/home.jpg';
import { useNavigate } from "react-router-dom";

const HomePage = () => {
    const navigate = useNavigate();

    const handleLogin = () => navigate('/auth/signin');
    const handleEligibilityCheck = () => navigate('/check-eligibility');
    return (
        <div className={'relative h-screen bg-cover bg-center bg-no-repeat text-[white]'} style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className={'absolute top-0 left-0 w-full h-full bg-[rgba(0,_0,_0,_0.7)]'} />
            <div className={'w-full h-full absolute top-0 left-0 flex items-center justify-center'}>
                <div className={'w-full flex flex-col justify-center items-center px-[20px] py-0 md:w-1/2'}>
                    <h1 className={'text-[3rem] leading-none text-center mb-12 md:text-[5rem]'}>Empower Your Education with Financial Support</h1>
                    <p className={'text-[1.4rem] text-center mb-28 opacity-80 md:text-[1.8rem]'}>
                        At Brighter Investment, we understand that funding your education can be a challenge. That’s why we’re here to help with financial assistance for your tuition fees, hostel accommodations, and stipends. Our mission is to make your academic journey smoother and more affordable.
                    </p>
                    <div className={'w-full flex flex-col justify-center gap-[20px] md:gap-[30px] md:w-[70%] md:flex-row'}>
                        <button className={'w-full p-4 text-black bg-primary rounded-[5px]'} onClick={handleEligibilityCheck} >
                            Check Your Eligibility
                        </button>
                        <button className={'w-full p-4 text-white border-[1px] border-[solid] border-primary rounded-[5px]'} onClick={handleLogin}>
                           Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;